import $ from 'jquery';
import '../../assets/js/src/components/organograma.js';
import CookieConsent from "react-cookie-consent";

const Lgpd = () => {

    function acceptCookies(id) {
        $(`#${id}`).trigger("click");
    }
    return (
        <>
            <CookieConsent expires={365} buttonStyle={{ display: "none" }}>

                <div className="container">
                    <div className="row">
                        <div className="col-md-8 mb-4 mb-md-0">
                            <p className="mb-0">
                                A Forluz utiliza cookies e outras tecnologias semelhantes para melhorar a sua experiência, de acordo com a nossa Política de Privacidade e, ao continuar navegando, você concorda com estas condições.
                            </p>
                        </div>
                        <div onClick={() => { acceptCookies("rcc-confirm-button") }} className="col-md-4  offset-xl-1 col-xl-3">
                            <a className="btn btn-primary btn-100 rounded d-block btn-lgpd"> Aceitar </a>
                        </div>
                    </div>
                </div>
            </CookieConsent>
        </>
    );

};
export default Lgpd;